import React from 'react'
import { Wrapper } from './PageHeader.styles'

export default function PageHeader({children}) {
  return (
    <Wrapper>{children}</Wrapper>
  )
}
